import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  eventForm: 0,
  inquiry: 0,
  memberInquiry: 0,
  earnSDollar: 0,
  redeem: 0,
  clubSLogin: 0,
};

const formStepSlice = createSlice({
  name: "formStep",
  initialState,
  reducers: {
    setFormStep: (state, action) => {
      const { formKey, step } = action.payload;
      state[formKey] = step;
    },
    resetFormStep: (state, action) => {
      const formKey = action?.payload?.formKey;
      if (formKey && formKey in state) {
        state[formKey] = 0;
      }
    },
    resetAllFormSteps: () => initialState,
  },
});

export const {
  setFormStep,
  resetFormStep,
  resetAllFormSteps,
} = formStepSlice.actions;
export default formStepSlice.reducer;
